import {
    GET_DASHBOARD_STATS,
    GET_DASHBOARD_DETAILED_STATS,
    DASHBOARD_LOADING,
    DASHBOARD_ERROR,
    GET_USER_ACTIVITY_REPORT,
    GET_USER_ANALYTICS_REPORT,
    GET_USER_SUMMARY_REPORT,
    USER_ACTIVITY_REPORT_LOADING,
    USER_ACTIVITY_REPORT_ERROR
} from '../actions/types';

const initialState = {
    stats: null,
    revenue: null,
    loading: false,
    error: null,
    userActivityReport: null,
    userAnalyticsReport: null,
    userSummaryReport: null,
    reportLoading: false,
    reportError: null
};

export default function dashboard(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case DASHBOARD_LOADING:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_DASHBOARD_STATS:
            return {
                ...state,
                stats: payload,
                loading: false,
                error: null
            };

        case GET_DASHBOARD_DETAILED_STATS:
            return {
                ...state,
                revenue: payload,
                loading: false,
                error: null
            };

        case DASHBOARD_ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };

        case USER_ACTIVITY_REPORT_LOADING:
            return {
                ...state,
                reportLoading: payload !== false,
                reportError: null
            };

        case GET_USER_ACTIVITY_REPORT:
            return {
                ...state,
                userActivityReport: payload,
                reportLoading: false,
                reportError: null
            };

        case GET_USER_ANALYTICS_REPORT:
            return {
                ...state,
                userAnalyticsReport: payload,
                reportLoading: false,
                reportError: null
            };

        case GET_USER_SUMMARY_REPORT:
            return {
                ...state,
                userSummaryReport: payload,
                reportLoading: false,
                reportError: null
            };

        case USER_ACTIVITY_REPORT_ERROR:
            return {
                ...state,
                reportLoading: false,
                reportError: payload
            };

        default:
            return state;
    }
}

